export enum NamedSubscription {
    CREATE_CARD_PRODUCT_SUB_TYPE_CHANGE,
}
